export default __webpack_public_path__ + "static/media/symbol-monochromo-white.d47e2b73.svg";